import React from 'react';
import * as S from './DropdownOptions.styled';

export interface DropdownOption {
  label: string;
  id: string;
  disabled?: boolean;
}

export interface DropdownOptionsProps {
  options: DropdownOption[];
  onClick: (option: DropdownOption) => void;
}

const DropdownOptions = React.forwardRef<
  HTMLUListElement,
  DropdownOptionsProps
>(({ options, onClick }, forwardedRef) => {
  return (
    <S.Container ref={forwardedRef}>
      {options.map(({ id, label, disabled }) => (
        <li key={id}>
          <S.Option
            type='button'
            disabled={disabled}
            onClick={() => onClick({ id, label })}
          >
            {label}
          </S.Option>
        </li>
      ))}
    </S.Container>
  );
});

export default DropdownOptions;
